import BestReportsContainer from "./BestReportsContainer";

export default BestReportsContainer;
